export default __webpack_public_path__ + "static/assets/med_pill_round_in_L0_solid_s_01_f.62e1a021.png";